import React from 'react';
import SidebarItem from './SidebarItem';

/**
 * Mobile-specific sidebar item component
 * Extends SidebarItem with mobile navigation behavior (auto-close sidebar)
 * @param {Object} props - Component props
 * @param {string} props.route - The route path for navigation
 * @param {string} props.label - Display text for the menu item
 * @param {React.ReactNode} props.icon - Icon component to display
 * @param {boolean} props.isSelected - Whether the item is currently selected
 * @param {boolean} props.isSidebarOpen - Whether the sidebar is in open/expanded state
 * @param {function} props.onClick - Click handler function for navigation
 * @param {function} props.onClose - Function to close the mobile sidebar
 * @param {string} [props.className] - Additional CSS classes
 */
const MobileSidebarItem = ({
  route,
  label,
  icon,
  isSelected,
  isSidebarOpen,
  onClick,
  onClose,
  className = '',
}) => {
  const handleClick = (route) => {
    onClick(route);
    onClose(); // Auto-close mobile sidebar after navigation
  };

  return (
    <SidebarItem
      route={route}
      label={label}
      icon={icon}
      isSelected={isSelected}
      isSidebarOpen={isSidebarOpen}
      onClick={handleClick}
      className={className}
    />
  );
};

export default MobileSidebarItem;
